export default __webpack_public_path__ + "static/media/hard-maple-full-double.b2de71e1.jpg";